module.exports = __webpack_public_path__ + "static/media/piano-b.9336788e.wav";